// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"8d6c8ac8","32":"8f6c0141","160":"170fffda","225":"9e466bfa","353":"121ad016","574":"31d6cfe0","664":"3b4d860c"}[chunkId] + ".chunk.css";
};